import { render } from "./SearchResultThird.vue?vue&type=template&id=d2af89be"
import script from "./SearchResultThird.vue?vue&type=script&lang=js"
export * from "./SearchResultThird.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__